import FilterMenu from "./FilterMenu";

const IconFilter = ({
  filterName,
  fieldName,
  options,
  appliedFilters,
  setAppliedFilters,
  icon,
  ...props
}) => {
  return (
    <FilterMenu
      filterName={filterName}
      fieldName={fieldName}
      options={options}
      appliedFilters={appliedFilters}
      setAppliedFilters={setAppliedFilters}
      icon={icon}
      {...props}
    />
  );
};

export default IconFilter;
